import { createReducer, on } from '@ngrx/store';
import { updateActions } from '../actions/update.actions';

export type UpdateStatus = 'idle' | 'downloading' | 'pending';

export interface UpdateState {
    status: UpdateStatus;
    // Held here rather than handed to the plugin via next(): next() arms the plugin's own
    // apply-on-background, which reloads the app while it is locked and wipes the in-memory
    // gate. The bridge applies this id at lock instead, behind a persisted relock flag.
    bundleId: string | null;
    version: string | null;
}

export const initialState: UpdateState = {
    status: 'idle',
    bundleId: null,
    version: null,
};

// A pending bundle survives both a newer download starting and that download failing: it stays
// on the device and stays applicable until something newer actually lands.
export const updateReducer = createReducer(
    initialState,
    on(updateActions.downloading, (state): UpdateState => ({ ...state, status: 'downloading' })),
    on(updateActions.downloaded, (_, { payload }): UpdateState => ({ status: 'pending', bundleId: payload.id, version: payload.version })),
    on(updateActions.failed, (state): UpdateState => ({ ...state, status: state.bundleId ? 'pending' : 'idle' })),
);
